import apiClient from './client';
import type { Household, HouseholdInvite } from '../types';

// =============================================
// Households API
// =============================================
export const householdsApi = {
  list: async (): Promise<Household[]> => {
    const response = await apiClient.get<Household[]>('/households');
    return response.data;
  },

  get: async (id: string): Promise<Household> => {
    const response = await apiClient.get<Household>(`/households/${id}`);
    return response.data;
  },

  create: async (name: string): Promise<Household> => {
    const response = await apiClient.post<Household>('/households', { name });
    return response.data;
  },

  update: async (id: string, name: string): Promise<Household> => {
    const response = await apiClient.put<Household>(`/households/${id}`, { name });
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/households/${id}`);
  },

  invite: async (householdId: string, email: string): Promise<HouseholdInvite> => {
    const response = await apiClient.post<HouseholdInvite>(
      `/households/${householdId}/invite`,
      { email }
    );
    return response.data;
  },

  acceptInvite: async (token: string): Promise<void> => {
    await apiClient.post('/households/accept-invite', { token });
  },

  getInvites: async (householdId: string): Promise<HouseholdInvite[]> => {
    const response = await apiClient.get<HouseholdInvite[]>(
      `/households/${householdId}/invites`
    );
    return response.data;
  },

  removeMember: async (householdId: string, userId: string): Promise<void> => {
    await apiClient.delete(`/households/${householdId}/members/${userId}`);
  },

  leave: async (householdId: string, userId: string): Promise<void> => {
    await apiClient.delete(`/households/${householdId}/members/${userId}`);
  },

  sync: async (householdId: string): Promise<{ message: string; synced: Record<string, number> }> => {
    const response = await apiClient.post<{ message: string; synced: Record<string, number> }>(
      `/households/${householdId}/sync`
    );
    return response.data;
  },
};
